/*****************************************************************
 *                          I18N                                 *
 *****************************************************************/

// Root path to Change Edition Dialog I18N in en_devel.json
export const CHANGE_EDITION_DIALOG_I18N_PATH = 'CHANGE_EDITION_DIALOG';
export const UPGRADE_EDITION_DIALOG_I18N_PATH = 'UPGRADE_EDITION_DIALOG';

//PATHS
const ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_I18N_PATH = `${CHANGE_EDITION_DIALOG_I18N_PATH}.ACTIVE_CAMPAIGN`;
const ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_I18N_PATH = `${UPGRADE_EDITION_DIALOG_I18N_PATH}.ACTIVE_CAMPAIGN`;

const ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_TEXT_I18N = {
  title: { key: `${ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_I18N_PATH}.TITLE` },
  selectEdition: { key: `${ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_I18N_PATH}.SELECT_EDITION` },
  selectContacts: { key: `${ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_I18N_PATH}.SELECT_CONTACTS` },
  current: { key: `${ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_I18N_PATH}.CURRENT` },
  confirmation: { key: `${ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_I18N_PATH}.CONFIRMATION` },
  cancelButton: { key: `${ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_I18N_PATH}.CANCEL_BUTTON` },
  changeEditionButton: { key: `${ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_I18N_PATH}.CHANGE_EDITION_BUTTON` },
};

const ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_TEXT_I18N = {
  title: { key: `${ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_I18N_PATH}.TITLE` },
  selectEdition: { key: `${ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_I18N_PATH}.SELECT_EDITION` },
  selectContacts: { key: `${ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_I18N_PATH}.SELECT_CONTACTS` },
  current: { key: `${ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_I18N_PATH}.CURRENT` },
  confirmation: { key: `${ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_I18N_PATH}.CONFIRMATION` },
  cancelButton: { key: `${ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_I18N_PATH}.CANCEL_BUTTON` },
  upgradeEditionButton: { key: `${ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_I18N_PATH}.UPGRADE_EDITION_BUTTON` },
};

/*****************************************************************
 *                        PAGE CONFIGS                           *
 *****************************************************************/

export const ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_CONFIG = {
  title: ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_TEXT_I18N.title,
  selectEdition: ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_TEXT_I18N.selectEdition,
  selectContacts: ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_TEXT_I18N.selectContacts,
  current: ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_TEXT_I18N.current,
  confirmation: ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_TEXT_I18N.confirmation,
  cancelButton: ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_TEXT_I18N.cancelButton,
  changeEditionButton: ACTIVE_CAMPAIGN_CHANGE_EDITION_DIALOG_TEXT_I18N.changeEditionButton,
};

export const ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_CONFIG = {
  title: ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_TEXT_I18N.title,
  selectEdition: ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_TEXT_I18N.selectEdition,
  selectContacts: ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_TEXT_I18N.selectContacts,
  current: ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_TEXT_I18N.current,
  confirmation: ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_TEXT_I18N.confirmation,
  cancelButton: ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_TEXT_I18N.cancelButton,
  upgradeEditionButton: ACTIVE_CAMPAIGN_UPGRADE_EDITION_DIALOG_TEXT_I18N.upgradeEditionButton,
};
